import { TmrBaseResource } from 'stylewhere/api'

export class EnumerationValues extends TmrBaseResource {
  static endpoint = 'api/v1/enumerationvalues' //profile
}
